import { authFetch } from "./authFetch";

const BASE_URL = window.env.API_BASE_URL;

export const updateFullName = async fullName => {
  try {
    const response = await authFetch(`${BASE_URL}/User/Update`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fullName }),
    });

    if (!response.ok) {
      throw new Error("Failed to update username");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteUserById = async id => {
  try {
    const response = await authFetch(`${BASE_URL}/User/DeleteById/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete User with ID ${id}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// Forgot password
export const forgotPassword = async email => {
  try {
    const response = await authFetch(`${BASE_URL}/User/ForgetPassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    const text = await response.text();

    if (!response.ok) {
      throw new Error(text || "_unknownError");
    }

    return text;
  } catch (error) {
    throw error;
  }
};

export const validateResetPassword = async (email, verificationCode) => {
  try {
    const response = await authFetch(`${BASE_URL}/User/ValidateResetPassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, verificationCode }),
    });

    if (!response.ok) {
      throw new Error("Failed to validate email");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (email, password, confirmPassword) => {
  try {
    const response = await authFetch(`${BASE_URL}/User/ResetPassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password, confirmPassword }),
    });

    if (!response.ok) {
      throw new Error("Failed to reset password");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// Change Password
export const changePassword = async (oldPassword, newPassword, confirmPassword) => {
  try {
    const response = await authFetch(`${BASE_URL}/User/ChangePassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ oldPassword, newPassword, confirmPassword }),
    });
    const text = await response.text();

    if (!response.ok) {
      throw new Error(text || "_unknownError");
    }

    return text;
  } catch (error) {
    throw error;
  }
};

// Change Mail
export const changeMail = async email => {
  try {
    const response = await authFetch(`${BASE_URL}/User/ChangeMail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    const text = await response.text();

    if (!response.ok) {
      throw new Error(text || "_unknownError");
    }
    return text;
  } catch (error) {
    throw error;
  }
};

export const validateOldEmail = async verificationCode => {
  try {
    const response = await authFetch(`${BASE_URL}/User/ValidateProvidedCode`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ verificationCode }),
    });

    if (!response.ok) {
      throw new Error("Failed to validate email");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const setNewMail = async email => {
  try {
    const response = await authFetch(`${BASE_URL}/User/SetNewEmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    const text = await response.text();
    if (!response.ok) {
      throw new Error(text || "_unknownError");
    }

    return text;
  } catch (error) {
    throw error;
  }
};

export const validateNewEmail = async verificationCode => {
  try {
    const response = await authFetch(`${BASE_URL}/User/ValidateNewEmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ verificationCode }),
    });
    const text = await response.text();
    if (!response.ok) {
      throw new Error(text || "_unknownError");
    }

    return text;
  } catch (error) {
    throw error;
  }
};
